// extracted by mini-css-extract-plugin
module.exports = {"oneClickDone":"CartAddedNotification_oneClickDone__kbhSw","oneClickDoneLink":"CartAddedNotification_oneClickDoneLink__xiSt0"};